(function () {
  const HEADING_SELECTOR = 'h3, h4';

  // --- helpers ---------------------------------------------------------------

  function splitIntoIntroAndSections(container) {
    const nodes = Array.from(container.childNodes);
    const hasHeadings = container.querySelector(HEADING_SELECTOR) !== null;

    // gather intro (before first heading)
    const introNodes = [];
    for (let n of nodes) {
      if (n.nodeType === 1 && n.matches(HEADING_SELECTOR)) break;
      introNodes.push(n.cloneNode(true));
    }

    // gather sections split on headings
    const sections = [];
    let current = null;
    let sawFirstHeading = false;

    nodes.forEach(n => {
      if (n.nodeType === 1 && n.matches(HEADING_SELECTOR)) {
        sawFirstHeading = true;
        current = { title: n.textContent.trim(), nodes: [] };
        sections.push(current);
      } else if (sawFirstHeading && current) {
        current.nodes.push(n.cloneNode(true));
      }
    });

    // If there was no intro and the first heading is literally "Details", move its
    // content into the intro and drop that pane.
    if (introNodes.length === 0 && sections[0] && /^details:?$/i.test(sections[0].title)) {
      introNodes.push(...sections[0].nodes);
      sections.shift();
    }

    return { hasHeadings, introNodes, sections };
  }

  // Smooth height animation for a <details> panel
  function setUpAnimation(detailsEl, contentEl) {
    const reduceMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;

    if (reduceMotion) {
      // No animation: ensure natural flow
      contentEl.style.height = '';
      contentEl.style.overflow = '';
      contentEl.style.transition = '';
      return;
    }

    contentEl.style.overflow = 'hidden';
    contentEl.style.height = '0px';
    contentEl.style.transition = 'height .25s ease';

    // When toggled, animate height from 0 ↔ content
    detailsEl.addEventListener('toggle', () => {
      if (detailsEl.open) {
        // opening
        const targetH = contentEl.scrollHeight;
        contentEl.style.height = targetH + 'px';
        // After transition completes, fix height to auto so content can grow/shrink
        const onEnd = () => {
          contentEl.style.height = 'auto';
          contentEl.removeEventListener('transitionend', onEnd);
        };
        contentEl.addEventListener('transitionend', onEnd);
      } else {
        // closing
        // If height is auto (from a previous open), snap to current pixels first
        if (contentEl.style.height === '' || contentEl.style.height === 'auto') {
          contentEl.style.height = contentEl.scrollHeight + 'px';
          // force reflow so browser registers the starting height
          // eslint-disable-next-line no-unused-expressions
          contentEl.offsetHeight;
        }
        requestAnimationFrame(() => {
          contentEl.style.height = '0px';
        });
      }
    });
  }

  function buildAccordion(sections) {
    const wrap = document.createElement('div');
    wrap.className = 'product-accordion__wrap';

    sections.forEach((sec) => {
      const details = document.createElement('details');
      details.className = 'product-accordion__item';
      // NOTE: no default open — all start closed

      const summary = document.createElement('summary');
      summary.className = 'product-accordion__summary';
      summary.textContent = sec.title;

      const content = document.createElement('div');
      content.className = 'product-accordion__content';
      sec.nodes.forEach(n => content.appendChild(n));

      details.appendChild(summary);
      details.appendChild(content);
      wrap.appendChild(details);

      setUpAnimation(details, content);
    });

    return wrap;
  }

  function findDescriptionContainer() {
    const detailsCol =
      document.querySelector('.product-details') ||
      document.querySelector('[id*="product-details"]') ||
      document.querySelector('[data-testid="product-details"]') ||
      document;

    let el =
      detailsCol.querySelector('[data-block-type="description"]') ||
      detailsCol.querySelector('[data-block="description"]') ||
      detailsCol.querySelector('.product__description') ||
      detailsCol.querySelector('.rte');

    if (!el) {
      el = Array.from(detailsCol.querySelectorAll('*')).find(n =>
        n.querySelector && (n.querySelector('h3') || n.querySelector('h4'))
      );
    }
    return el || null;
  }

  // --- init ------------------------------------------------------------------

  function init() {
    const container = findDescriptionContainer();
    if (!container) return;

    const { hasHeadings, introNodes, sections } = splitIntoIntroAndSections(container);
    if (!hasHeadings || sections.length === 0) return; // no headings → keep theme default

    // Build new content: intro (if any) + accordion
    const frag = document.createDocumentFragment();

    if (introNodes.length) {
      const intro = document.createElement('div');
      intro.className = 'product-accordion__intro rte';
      introNodes.forEach(n => intro.appendChild(n));
      frag.appendChild(intro);
    }

    frag.appendChild(buildAccordion(sections));

    // Replace original description with our fragment
    while (container.firstChild) container.removeChild(container.firstChild);
    container.appendChild(frag);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
  // Close other sections when one opens (optional)
document.addEventListener('click', function(e) {
  const summary = e.target.closest('.product-accordion__summary');
  if (!summary) return;
  const item = summary.parentElement;            // <details>
  const wrap = item.parentElement;               // .product-accordion__wrap
  // Wait for the current one to open, then close siblings
  requestAnimationFrame(() => {
    if (!item.open) return;
    wrap.querySelectorAll('.product-accordion__item').forEach(d => {
      if (d !== item && d.open) d.open = false;
    });
  });
}, { passive: true });

})();

